import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

export interface ChatMessage {
  role: 'user' | 'ai';
  content: string;
}

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  private http = inject(HttpClient);
  private apiUrl = 'http://localhost:8080/api/v1/chat';

  // 1. STATE LIVES HERE NOW (Survives route changes)
  messages = signal<ChatMessage[]>([]);
  private hasLoadedHistory = false;

  getSessionId(): string {
    let sessionId = localStorage.getItem('chat_session_id');
    if (!sessionId) {
      sessionId = crypto.randomUUID();
      localStorage.setItem('chat_session_id', sessionId);
    }
    return sessionId;
  }

  // 2. Fetch history only ONCE per session
  loadHistory() {
    if (this.hasLoadedHistory) return; 

    const sessionId = this.getSessionId();
    this.http.get<{ messages: ChatMessage[] }>(`${this.apiUrl}/history/${sessionId}`)
      .subscribe({
        next: (res) => {
          this.messages.set(res.messages);
          this.hasLoadedHistory = true;
        },
        error: (err) => console.error('Failed to load history', err)
      });
  }

  // 3. Centralize message updating
  sendMessage(query: string): Observable<{ reply: string }> {
    // Optimistically update the UI instantly
    this.messages.update(msgs => [...msgs, { role: 'user', content: query }]);

    const payload = {
      session_id: this.getSessionId(),
      query: query,
      history: [] 
    };

    return this.http.post<{ reply: string }>(this.apiUrl, payload).pipe(
      // When backend responds, update the signal automatically
      tap(res => {
        this.messages.update(msgs => [...msgs, { role: 'ai', content: res.reply }]);
      })
    );
  }
}